import sensors from '@/utils/sensors/sensors_config'

// 弹窗
export default {
    //序号7-PopExposure-弹窗曝光
    $pope(page_name: any, pop_name: any) {
        sensors.track('PopExposure', {
            page_name,// 页面名称
            pop_name //弹窗名称
        })
    },
    //序号8-PopClick-弹窗点击
    $popeClick(page_name: any, pop_name: any,button_name:any) {
        sensors.track('PopClick', {
            page_name,// 页面名称
            pop_name, //弹窗名称
            button_name//按钮名称
        })
    },
    //序号9-PopClose-弹窗曝光
    $popeClose(page_name: any, pop_name: any, if_close: any) {
        sensors.track('PopClose', {
            page_name,// 页面名称
            pop_name, //弹窗名称
            if_close //是否关闭成功
        })
    },
}